import React from "react";
import { NavLink } from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";

const Navbar = () => {

  const regName = localStorage.getItem("regName") || "User";
  const branchCode = localStorage.getItem("branchcode") || "";

  return (

    <nav
      className="navbar navbar-expand-lg fixed-top"
      style={{
        background: "linear-gradient(to right, #0d6efd, #0dcaf0)",
        padding: "10px 18px",
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        zIndex: 2000,
      }}
    >

      <div className="container-fluid">

        {/* BRAND */}
        <NavLink
          to="/ict"
          className="navbar-brand d-flex align-items-center text-white fw-bold"
        >

          <div
            className="bg-white text-primary rounded-circle d-flex align-items-center justify-content-center me-2"
            style={{
              width: "38px",
              height: "38px",
            }}
          >
            <Icon.PeopleFill size={18} />
          </div>

          <div>
            <div style={{ fontSize: "18px" }}>
              HRIS
            </div>

            {/* <small style={{ fontSize: "11px", opacity: 0.9 }}>
              Human Resource Information System
            </small> */}
          </div>

        </NavLink>

        {/* MOBILE TOGGLE */}
        <button  className="navbar-toggler bg-white" type="button" data-bs-toggle="collapse" data-bs-target="#navbarContent" >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* MENU */}
        <div
          className="collapse navbar-collapse" id="navbarContent">

          {/* RIGHT SIDE */}
          <div className="ms-auto d-flex align-items-center gap-3 mt-3 mt-lg-0">

            {/* USER INFO */}
            <div
              className="d-flex align-items-center bg-white px-3 py-2 rounded-pill shadow-sm"
              style={{
                fontSize: "14px",
              }}
            >

              <Icon.PersonCircle
                className="me-2 text-primary"
                size={18}
              />

              <span className="fw-semibold text-dark">
                {regName}
              </span>

              <span className="text-muted ms-1">
                @{branchCode}
              </span>

            </div>

            {/* LOGOUT */}
            <a href="/" className="btn btn-danger rounded-pill px-3 d-flex align-items-center" >
              <Icon.BoxArrowRight className="me-1" />
              Logout
            </a>

          </div>

        </div>

      </div>

    </nav>

  );
};

export default Navbar;